import React, { Component } from 'react';
import fx from 'money';
import styled from 'styled-components';
import axios from 'axios';
import FiatCurrencySelector from '../FiatCurrencySelector';
import CryptoIcon from './CryptoIcon';
import accounting from 'accounting';
import getSymbolFromCurrency from 'currency-symbol-map';
import MediaQuery from 'react-responsive';
import FreeTextSearch from './FreeTextSearch';
import { renderMoney } from './money-utils';
import { sortBy } from './list-utils';
import ListItemTable from './ListItemTable';
import {
  media,
  redOrGreen,
  Toolbar,
  CryptoListContainer,
  FreeTextSearchInput,
  List,
  ListHeader,
  ListItemHeaderValue,
  ListItem,
  ListItemValue,
  Button,
} from './styles';

const CRYPTO_CURRENCY_API = 'https://currencyconverter.cloud/api/crypto/rank/';
const FIAT_CURRENCY_API = 'https://currencyconverter.cloud/api/fiat';

//const CRYPTO_CURRENCY_API = 'http://localhost:5000/api/crypto/rank/'
//const FIAT_CURRENCY_API = 'http://localhost:5000/api/fiat'

const sortOptions = {
  isDescending: true,
  values: {
    MARKET_CAP: 'market_cap_usd',
    PRICE: 'price_usd',
    CHANGE_1H: 'percent_change_1h',
    CHANGE_24H: 'percent_change_24h',
    CHANGE_7D: 'percent_change_7d',
  },
};

export default class CryptoList extends Component {
  constructor() {
    super();
    this.state = {
      currencies: [],
      selectedFiatCurrency: { value: 'USD', label: 'Yhdysvaltain dollari' },
      currencyCount: 20,
      sorting: {
        isDescending: sortOptions.isDescending,
        sortCol: sortOptions.values.MARKET_CAP,
      },
      isMobileDevice: false,
      freeTextSearchValue: '',
    };
    fx.base = 'USD';
    this.onFreeTextSearchUpdate = this.onFreeTextSearchUpdate.bind(this);
  }

  showMoreCryptos = (min, max) => {
    this.setState({ currencyCount: this.state.currencyCount + max }, () => {
      axios
        .get(`${CRYPTO_CURRENCY_API}${min}/${this.state.currencyCount}`)
        .then(result => {
          this.setState({ currencies: result.data.currencies });
        })
        .catch(e => {
          console.log(e);
        });
    });
  };

  componentDidMount() {
    axios
      .get(FIAT_CURRENCY_API)
      .then(result => {
        fx.rates = result.data.currencies;
      })
      .catch(e => {
        console.log(e);
      });

    axios
      .get(CRYPTO_CURRENCY_API + `0/${this.state.currencyCount}`)
      .then(result => {
        this.setState({ currencies: result.data.currencies });
      })
      .catch(e => {
        console.log(e);
      });
  }

  updateFiatCurrency = fiatCurrency => {
    this.setState({ selectedFiatCurrency: fiatCurrency });
  };

  calculateCurrencyRate = currencyAmount => {
    if (!currencyAmount) return 0;
    return fx(currencyAmount)
      .from('USD')
      .to(this.state.selectedFiatCurrency.value);
  };

  renderMoney = value => {
    return renderMoney(
      this.calculateCurrencyRate(value),
      this.state.selectedFiatCurrency.value
    );
  };

  // Switch direction when new sort column is equal to previous
  // Also always sets sort direction to descending when changing sort column
  sortCryptoList = value => {
    const isDescending =
      this.state.sorting.sortCol === value
        ? !this.state.sorting.isDescending
        : this.state.sorting.isDescending;
    const sortedList = this.state.currencies.sort(
      sortBy(value, isDescending, parseFloat)
    );
    this.setState({
      currencies: sortedList,
      sorting: {
        isDescending: isDescending,
        sortCol: value,
      },
    });
  };

  filterCurrencies = currency => {
    return (
      currency.name.toLowerCase().indexOf(this.state.freeTextSearchValue) >
        -1 ||
      currency.symbol.toLowerCase().indexOf(this.state.freeTextSearchValue) > -1
    );
  };

  onFreeTextSearchUpdate = e => {
    this.setState({ freeTextSearchValue: e.target.value.toLowerCase() });
  };

  render() {
    return (
      <CryptoListContainer>
        <Toolbar>
          <FreeTextSearchInput
            placeholder={'Hae...'}
            onChange={this.onFreeTextSearchUpdate}
          />
          <FiatCurrencySelector
            defaultCurrency={{ value: this.state.selectedFiatCurrency }}
            onFiatCurrencyChange={this.updateFiatCurrency}
          />
        </Toolbar>
        <List>
          <ListHeader key={'header'}>
            <ListItemHeaderValue style={{ width: '40px' }}>
              Rank
            </ListItemHeaderValue>
            <ListItemHeaderValue>Name</ListItemHeaderValue>
            <ListItemHeaderValue style={{ width: '40px' }}>
              Code
            </ListItemHeaderValue>
            <ListItemHeaderValue
              onClick={this.sortCryptoList.bind(
                null,
                sortOptions.values.MARKET_CAP
              )}
            >
              Market cap
            </ListItemHeaderValue>
            <ListItemHeaderValue
              onClick={this.sortCryptoList.bind(null, sortOptions.values.PRICE)}
            >
              Price
            </ListItemHeaderValue>
            <ListItemHeaderValue
              onClick={this.sortCryptoList.bind(
                null,
                sortOptions.values.CHANGE_1H
              )}
              style={{ width: '60px' }}
            >
              1h
            </ListItemHeaderValue>
            <ListItemHeaderValue
              onClick={this.sortCryptoList.bind(
                null,
                sortOptions.values.CHANGE_24H
              )}
              style={{ width: '60px' }}
            >
              24h
            </ListItemHeaderValue>
            <ListItemHeaderValue
              onClick={this.sortCryptoList.bind(
                null,
                sortOptions.values.CHANGE_7D
              )}
              style={{ width: '60px' }}
            >
              7d
            </ListItemHeaderValue>
          </ListHeader>

          {this.state.currencies.filter(this.filterCurrencies).map(currency => (
            <ListItem key={currency.id}>
              <MediaQuery maxWidth={1024}>
                <ListItemTable
                  currency={currency}
                  selectedFiatCurrency={this.state.selectedFiatCurrency.value}
                />
              </MediaQuery>

              <MediaQuery minWidth={1025}>
                <ListItemValue style={{ width: '40px' }}>
                  {currency.rank}
                </ListItemValue>
                <ListItemValue>
                  <CryptoIcon symbol={currency.symbol} /> {currency.name}
                </ListItemValue>
                <ListItemValue style={{ width: '40px' }}>
                  {currency.symbol}
                </ListItemValue>
                <ListItemValue>
                  {this.renderMoney(currency.market_cap_usd)}
                </ListItemValue>
                <ListItemValue>
                  {this.renderMoney(currency.price_usd)}
                </ListItemValue>
                <ListItemValue style={{ width: '60px' }}>
                  <span style={redOrGreen(currency.percent_change_1h)}>
                    {currency.percent_change_1h}%
                  </span>
                </ListItemValue>
                <ListItemValue style={{ width: '60px' }}>
                  <span style={redOrGreen(currency.percent_change_24h)}>
                    {currency.percent_change_24h}%
                  </span>
                </ListItemValue>
                <ListItemValue style={{ width: '60px' }}>
                  <span style={redOrGreen(currency.percent_change_7d)}>
                    {currency.percent_change_7d}%
                  </span>
                </ListItemValue>
              </MediaQuery>
            </ListItem>
          ))}
        </List>
        {this.state.currencies.length >= 10 &&
          this.state.currencyCount < 2000 && (
            <Button onClick={this.showMoreCryptos.bind(null, 0, 100)}>
              Näytä 100 lisää
            </Button>
          )}
      </CryptoListContainer>
    );
  }
}
